module.exports = __webpack_public_path__ + "img/finishChecked2.bc935335.png";